import { useState } from 'react';

import { addMonths, startOfDay, startOfMonth } from 'date-fns';

export function useCalendarPageState(today: Date) {
    // `null` until picked/browsed on purpose, so both keep following `today` across midnight.
    const [pickedDay, setPickedDay] = useState<Date | null>(null);
    const [browsedMonth, setBrowsedMonth] = useState<Date | null>(null);
    const [isPickerOpen, setIsPickerOpen] = useState(false);

    const selectedDay = pickedDay ?? today;
    const shownMonth = browsedMonth ?? startOfMonth(selectedDay);

    function selectDay(day: Date) {
        setPickedDay(startOfDay(day));
        setBrowsedMonth(null);
    }

    function showNextMonth() {
        setBrowsedMonth((month) => addMonths(month ?? startOfMonth(selectedDay), 1));
    }

    function showPreviousMonth() {
        setBrowsedMonth((month) => addMonths(month ?? startOfMonth(selectedDay), -1));
    }

    function showMonth(month: Date) {
        setBrowsedMonth(startOfMonth(month));
    }

    function goToToday() {
        setPickedDay(null);
        setBrowsedMonth(null);
    }

    function togglePicker() {
        if (!isPickerOpen) {
            setBrowsedMonth(null);
        }
        setIsPickerOpen((open) => !open);
    }

    return {
        selectedDay,
        shownMonth,
        isPickerOpen,
        selectDay,
        showNextMonth,
        showPreviousMonth,
        showMonth,
        goToToday,
        togglePicker,
    };
}
